import React, { useState } from "react";
import "./BePartner.css";
import axios from "axios";

const BePartner = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://pharmabackend-1.onrender.com/api/contact", formData);
      alert(response.data.message);
      setFormData({
        name: "",
        company: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      alert("Error submitting form");
      console.error(error);
    }
  };

  return (
    <div className="be-partner-container">
      {/* Left Side - Contact Information */}
      <div className="contact-info">
        <h4 className="contact-title">CONTACT ME</h4>
        <h2 className="contact-heading">
          I'd love to work together on your next project!
        </h2>
        <div className="contact-details">
          <p>📍 97 HMT Layout, RT Nagar, Bangalore, 560032</p>
          <p>📞 012-345-6789</p>
          <p>📧 support@hospipharma.com</p>
        </div>
      </div>

      {/* Right Side - Contact Form */}
      <div className="contact-form">
        <form onSubmit={handleSubmit}>
          <div className="name-fields">
            <input
              className="bepartner-input"
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              className="bepartner-input"
              type="text"
              name="company"
              placeholder="Company / Hospital Name"
              value={formData.company}
              onChange={handleChange}
              required
            />
          </div>
          <input
            className="bepartner-input"
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            className="bepartner-input"
            type="phone"
            name="phone"
            placeholder="Mobile"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <textarea
            className="bepartner-text"
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button className="bepartner-btn" type="submit">
            CONNECT ME
          </button>
        </form>
      </div>
    </div>
  );
};

export default BePartner;